import axios from 'axios'
import qs from 'qs'
export const isDev = process.env.VUE_APP_MODE === 'test'
export const devhost = "gj.rrxue.cn"
// export const devhost = "wx.feishuonline.com"
// export const devhost = "wx.syxtjy.cn"
// export const devhost = "xuelu0829.1818w.cn"


axios.interceptors.request.use(function (config) {
  let token = localStorage.getItem("usertoken")
  var host = window.location.host
  if (process.env.NODE_ENV === 'development') {
    host = devhost
  }
  if (token == undefined) {
    token = ""
    if (process.env.NODE_ENV === 'development') {
      token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1bmlvbmlkIjoiMTE5NDMiLCJ1bmlvbm5hbWUiOiJycnh1ZSIsInN0YWZmaWQiOjAsInN0YWZmbmFtZSI6IiIsInVzZXJyb2xlIjowLCJ1bmlvbnR5cGUiOjAsImlzc3VlciI6InVuaW9uIiwiYXVkaWVuY2UiOiIifQ.JnNcsFz7C1uwEroKw5RrFJUlRSYuqLVL7PO-2s_pqkQ"
      // token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyaWQiOjE0NjQ5NzEyLCJ1c2VybmFtZSI6Ijk2NjQ2MDZhIiwidW5pb25pZCI6IjUzNjAzIiwiaXNzdWVyIjoidXNlciIsImF1ZGllbmNlIjoiIn0.kZYaOGayYhOWg-wGv16BavziWVvaKTKje129s-89Kmg"
    }
  }
  config.params = {
    host: host,
    token: token,
    ...config.params
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// export const uri = 'https://uapi.233.com'
// export const uri = isDev ? 'http://192.168.0.164' : 'https://uapi.233.com'
export const uri = isDev ? 'https://uapi.233.com' : 'https://uapi.233.com'

export const GetCookies = (params, callback) => get('/unioninfo/promote/GetCookies', params, callback)// 获取cookies
export const GetCategoryChildClassAndAreaList = (params, callback) => get('/Course/Category/GetCategoryChildClassAndAreaList', params, callback)// 获取当前分类名称、站点同级其他分类、地区信息、banner图、活动图、app地址，host传二级域名
export const GetUnionBkzn = (params, callback) => get('/unioninfo/BkznPrescription/GetUnionBkzn', params, callback)// 前端获取考试指南（如果机构保存了就取自己的 反之取cms的）open=0 取热门课程 open=1 取返回值
export const GetCategoryAuditionCourseList = (params, callback) => get('/Course/Category/GetCategoryAuditionCourseList', params, callback)// 获取通用版试听课程
export const GetExaminationCountDown = (params, callback) => get('/Course/Category/GetExaminationCountDown', params, callback)// 获取考试倒计时
export const GetCategoryTeacherList = (params, callback) => get('/Course/Category/GetCategoryTeacherList', params, callback)// 获取通用版老师信息
export const GetCategoryTaoCanCourseList = (params, callback) => get('/Course/Category/GetCategoryTaoCanCourseList', params, callback)// 获取套餐信息
export const GetCategoryJiChuCourseList = (params, callback) => get('/Course/Category/GetCategoryJiChuCourseList', params, callback)// 获取基础班
export const GetCategoryFineBanJiContrastList = (params, callback) => get('/Course/Category/GetCategoryFineBanJiContrastList', params, callback)// 获取高级平台对比
export const GetCategoryNormBanJiContrastList = (params, callback) => get('/Course/Category/GetCategoryNormBanJiContrastList', params, callback)// 获取普通平台对比
export const GetCategoryBookList = (params, callback) => get('/Course/Category/GetCategoryBookList', params, callback)// 获取官方教材
export const GetCategoryTikuPaperList = (params, callback) => get('/Course/Category/GetCategoryTikuPaperList', params, callback)// 获取题库试卷

export const GetUnionLogoByHost = (params, callback) => get('/unioninfo/info/GetUnionLogoByHost', params, callback)// 获取logo
export const GetPhoneByHost = (params, callback) => get('/unioninfo/info/GetPhoneByHost', params, callback)// 获取顶部电话
export const GetFooterByHost = (params, callback) => get('/unioninfo/info/GetFooterByHost', params, callback)// 获取页尾
export const GetSeniorFlag = (params, callback) => get('/unioninfo/info/GetSeniorFlag', params, callback)// 获取是否高级平台
export const GetLoginStatus = (params, callback) => get('/unioninfo/info/GetLoginStatus', params, callback)// 获取登录状态
export const GetKeFuByHost = (params, callback) => get('/unioninfo/info/GetKeFuByHost', params, callback)// 获取客服信息
export const GetUnionPermission = (params, callback) => get('/UnionInfo/Info/GetUnionPermission', params, callback)// 常见问题

export const getUnionConfig = (params,callback) => get('/UnionInfo/Info/GetPuConfig',params,callback);//配置
export const getBook = (params, callback) => get('/Course/Course/GetBook', params, callback);//获取赠送书籍信息

export const Statistics = (params, callback) => get('/UnionInfo/Info/Statistics', params, callback)


export const get = (api, params, callback) => axios.get(uri + api, {
  params: params
}).then(res => {
  callback(res.data)
})

export const post = (api, params, callback) => axios.post(uri + api, qs.stringify(params))
.then(res => {
  callback(res.data)
})
